import { UserDTO } from "../user.model.ts";

export enum InterimReason {
  LEAVE = "LEAVE",
  ILLNESS = "ILLNESS",
  MISSION = "MISSION",
  OTHER = "OTHER",
}

export const interimReasonList = [
  { name: "Congé", code: InterimReason.LEAVE },
  { name: "Maladie", code: InterimReason.ILLNESS },
  { name: "Mission", code: InterimReason.MISSION },
  { name: "Autre", code: InterimReason.OTHER },
];

export interface InterimAgentPostDTO {
  absentAgentId: number;
  interimAgentId: number;
  reason: InterimReason;
  startDate: string;
  endDate: string;
  comment?: string;
}

export interface InterimAgentDTO {
  id: number;
  absentAgent: UserDTO;
  interimAgent: UserDTO;
  reason: InterimReason;
  startDate: string;
  endDate: string;
  comment?: string;
  active: boolean;
  createdAt: string;
}
